import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyCpF5sAZwPwvsxl6H2QNpF_jnD4CZ_4TWU',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'toletforrent-31e39.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'toletforrent-31e39',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'toletforrent-31e39.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '689443722680',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:689443722680:android:853717e1409da9b4fb6b4d',
};

let appInstance = null;
let authInstance = null;

function getAuthInstance() {
  if (!authInstance) {
    appInstance = initializeApp(firebaseConfig);
    authInstance = getAuth(appInstance);
  }
  return authInstance;
}

export const auth = new Proxy({}, {
  get(target, prop, receiver) {
    const instance = getAuthInstance();
    const value = Reflect.get(instance, prop);
    if (typeof value === 'function') {
      return value.bind(instance);
    }
    return value;
  },
  set(target, prop, value) {
    const instance = getAuthInstance();
    return Reflect.set(instance, prop, value);
  }
});

export default {
  get app() {
    if (!appInstance) {
      getAuthInstance();
    }
    return appInstance;
  }
};
